// Hardcoded PMI grade -> chemical composition (Min/Max %) data.
// Source: PMI_GRADE.xlsx supplied by client.
// DO NOT create a Grade Master table / CRUD / API for this data — per requirement,
// this file is the single source of truth for grade -> element composition.
//
// Each element: { symbol, min, max } — min/max are strings ('' when not specified,
// e.g. a grade that only defines a Max value).

const pmiGrades = [
  {
    name: 'HE30',
    elements: [
      { symbol: 'Mn', min: '0.40', max: '1.00' },
      { symbol: 'Cu', min: '', max: '0.10' },
      { symbol: 'Zn', min: '0.00', max: '0.20' },
      { symbol: 'Fe', min: '', max: '0.50' },
    ],
  },
  {
    name: 'ALU6061',
    elements: [
      { symbol: 'Al', min: '95.85', max: '98.56' },
      { symbol: 'Mn', min: '', max: '0.15' },
      { symbol: 'Cu', min: '0.15', max: '0.40' },
      { symbol: 'Cr', min: '0.04', max: '0.35' },
      { symbol: 'Zn', min: '0.00', max: '0.25' },
      { symbol: 'Fe', min: '', max: '0.70' },
    ],
  },
  {
    name: 'D2',
    elements: [
      { symbol: 'Cr', min: '11.00', max: '13.00' },
      { symbol: 'Mo', min: '0.70', max: '1.20' },
      { symbol: 'Mn', min: '0.00', max: '0.60' },
      { symbol: 'Ni', min: '', max: '0.30' },
    ],
  },
  {
    name: 'SS316',
    elements: [
      { symbol: 'Cr', min: '16.00', max: '18.00' },
      { symbol: 'Mn', min: '', max: '2.00' },
      { symbol: 'Ni', min: '10.00', max: '14.00' },
      { symbol: 'Mo', min: '2.00', max: '3.00' },
    ],
  },
  {
    name: 'SS304',
    elements: [
      { symbol: 'Cr', min: '18.00', max: '20.00' },
      { symbol: 'Mn', min: '', max: '2.00' },
      { symbol: 'Ni', min: '8.00', max: '10.00' },
    ],
  },
  {
    name: 'EN41B',
    elements: [
      { symbol: 'Cr', min: '1.40', max: '1.80' },
      { symbol: 'Mn', min: '', max: '0.65' },
      { symbol: 'Mo', min: '0.10', max: '0.25' },
      { symbol: 'Ni', min: '', max: '0.40' },
    ],
  },
  {
    name: 'EN24',
    elements: [
      { symbol: 'Cr', min: '1.00', max: '1.40' },
      { symbol: 'Ni', min: '1.30', max: '1.70' },
      { symbol: 'Mn', min: '0.45', max: '0.70' },
      { symbol: 'Mo', min: '0.20', max: '0.35' },
    ],
  },
  {
    name: 'EN19',
    elements: [
      { symbol: 'Mn', min: '0.50', max: '0.80' },
      { symbol: 'Cr', min: '0.90', max: '1.50' },
      { symbol: 'Mo', min: '0.20', max: '0.40' },
    ],
  },
  {
    name: 'SS410/420',
    elements: [
      { symbol: 'Cr', min: '11.50', max: '13.50' },
      { symbol: 'Si', min: '', max: '1.00' },
      { symbol: 'Mn', min: '', max: '1.00' },
    ],
  },
  {
    name: 'ALU7075',
    elements: [
      { symbol: 'Mn', min: '', max: '0.3' },
      { symbol: 'Zn', min: '5.1', max: '6.1' },
      { symbol: 'Cu', min: '1.2', max: '2.00' },
      { symbol: 'Fe', min: '', max: '0.5' },
      { symbol: 'Cr', min: '0.18', max: '0.28' },
    ],
  },
  {
    name: 'ALU 5058',
    elements: [
      { symbol: 'Al', min: '95.02', max: '98.30' },
      { symbol: 'Mn', min: '0.40', max: '1.00' },
      { symbol: 'Cr', min: '', max: '0.25' },
      { symbol: 'Zn', min: '0.00', max: '0.20' },
      { symbol: 'Fe', min: '', max: '0.50' },
    ],
  },
  {
    name: 'EN8',
    elements: [
      { symbol: 'Mn', min: '0.10', max: '0.40' },
    ],
  },
  {
    name: '20MNCR5',
    elements: [
      { symbol: 'Mn', min: '1.00', max: '1.30' },
      { symbol: 'Cr', min: '0.80', max: '1.10' },
    ],
  },
  {
    name: 'EN36',
    elements: [
      { symbol: 'Si', min: '0.10', max: '0.35' },
      { symbol: 'Mn', min: '0.60', max: '0.80' },
    ],
  },
  {
    name: 'EN8D/C45',
    elements: [
      { symbol: 'Mn', min: '0.70', max: '0.90' },
    ],
  },
  {
    name: 'SS431',
    elements: [
      { symbol: 'Cr', min: '18.00', max: '20.00' },
      { symbol: 'Mn', min: '', max: '2.00' },
      { symbol: 'Ni', min: '8.00', max: '10.00' },
    ],
  },
];

// Returns the option list for the Autocomplete (array of grade names).
export const getPmiGradeOptions = () => pmiGrades.map((g) => g.name);

// Returns the element composition [{symbol,min,max}] for a given grade name.
// Returns [] for custom / unknown grades (freeSolo typed values).
export const getElementsForGrade = (gradeName) => {
  if (!gradeName) return [];
  const found = pmiGrades.find(
    (g) => g.name.toLowerCase() === String(gradeName).toLowerCase()
  );
  return found ? found.elements : [];
};

export default pmiGrades;
